var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticStyle:{"width":"24px","height":"24px"},attrs:{"fill":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7,10L12,15L17,10H7Z","fill":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }